var config = require('../config/settings.json');

import Vue from 'vue';
import Tools from "../store/tools.js";

export default {
    updateById(context, id, question, callback){
      context.$root.$emit('loading', true);
      context.$http.patch(config.api_url + "questions/"+id,question).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    }
}



// WEBPACK FOOTER //
// ./src/requests/questions.js